import React, { Component } from 'react';
import {connect} from 'react-redux';
import { SessionDetail } from './sessionDetail.component';
import MainPageComponent from '../../_generic/main.page.component';

import { fetchSessions } from '../../../store/actions/session.actions'
import LoadingComponent from '../../common/loading.component';
import {PropTypes} from 'prop-types';
import {withRouter} from 'react-router-dom'
class SessionDetailContainer extends Component {

  componentDidMount() {

    this.props.fetchSessions();

  }
  render() {
    if (this.props.isFetchingSessions) {
      return <LoadingComponent />;
    }

    return (
      <MainPageComponent projectView={true} title="Project">
     <SessionDetail session={this.props.sessions[this.props.match.params.sessionId]} currentFileId={this.props.currentFileId} ></SessionDetail>
  </MainPageComponent>
    );
  }
}
SessionDetailContainer.propTypes = {
  sessions: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    files: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      displayname: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,

    })),
  }).isRequired,
  isFetchingSessions: PropTypes.bool.isRequired,
  fetchSessions: PropTypes.func.isRequired,
  currentFileId: PropTypes.string,
};

const mapStateToProps = ({
  sessions,
  status: {
    isFetchingSessions,
    currentFileId,
  },
}) => ({
  sessions,
  isFetchingSessions,
  currentFileId,
});
export default withRouter(connect(mapStateToProps, { fetchSessions })(SessionDetailContainer));
